
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ApplicationExceptionHandler } from '@schemax-whatsapp/backend-utils';
import { BiMessageResponse, CommonResponse, CompanyBiMessageResponse, ExcelImportResponse, WhatsappLogResponseModel } from '@schemax-whatsapp/shared-models';
import { ModuleIdRequest } from '../module/models/module-id.request';
import { BiMessageService } from './bi-message.service';
import { BiMessageIdRequest } from './models/bi-message-id.request';
import { BiMessageModel } from './models/bi-message.model';
import { CompanyIdBiMsgIdRequest } from './models/company-bi-message-ids.request';
import { CompanyIdReq, CompanyModuleIdRequest } from './models/company-module-id.request';
import { WhatsappLogRequest } from '../company/models/company-id.request';
import { WhatsappLogsDto } from '../entity/repository/whatsapp-logs-dto';

@Controller('/bi-message')
export class BiMessageController {
    constructor(
        private biMsgService: BiMessageService,
        private applicationExceptionHandler: ApplicationExceptionHandler
    ) {

    }

    @Post('/createBiMessage')
    async createBiMessage(@Body() msgReq: BiMessageModel): Promise<BiMessageResponse> {
        try {
            return await this.biMsgService.createBiMessage(msgReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(BiMessageResponse, error);
        }
    }

    @Post('/updateBiMessage')
    async updateBiMessage(@Body() msgReq: BiMessageModel): Promise<BiMessageResponse> {
        try {
            return await this.biMsgService.updateBiMessage(msgReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(BiMessageResponse, error);
        }
    }

    @Post('/deleteBiMessage')
    async deleteBiMessage(@Body() biMsgIdReq: BiMessageIdRequest): Promise<BiMessageResponse> {
        try {
            return await this.biMsgService.deleteBiMessage(biMsgIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(BiMessageResponse, error);
        }
    }

    @Post('/getAllBiMessagesForModule')
    async getAllBiMessagesForModule(@Body() moduleIdReq: ModuleIdRequest): Promise<BiMessageResponse> {
        try {
            return await this.biMsgService.getAllBiMessagesForModule(moduleIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(BiMessageResponse, error);
        }
    }

    // ------------------------- Company Bi Messages ---------------------------

    @Post('/mapBiMessageToCompany')
    async mapBiMessageToCompany(@Body() companyIdBiMsgIdReq: CompanyIdBiMsgIdRequest): Promise<BiMessageResponse> {
        try {
            return await this.biMsgService.mapBiMessageToCompany(companyIdBiMsgIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(BiMessageResponse, error);
        }
    }

    @Post('/getAllCompanyBiMessagesForModule')
    async getAllCompanyBiMessagesForModule(@Body() companyModuleIdReq?: CompanyModuleIdRequest): Promise<CompanyBiMessageResponse> {
        try {
            return await this.biMsgService.getAllCompanyBiMessagesForModule(companyModuleIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CompanyBiMessageResponse, error);
        }
    }
    
    @Post('/biMessageStatusApproval')
    async biMessageStatusApproval(@Body() req:BiMessageModel): Promise<BiMessageResponse> {
        try {
            return await this.biMsgService.biMessageStatusApproval(req,false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(BiMessageResponse, error);
        }
    }
    
    @Post('/getwhatsappLogsreport')
    async getwhatsappLogsreport(@Body() req:WhatsappLogRequest): Promise<CommonResponse> {
        try {
            return await this.biMsgService.getwhatsappLogsreport(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getAllModulesandCompany')
    async getAllModulesandCompany(@Body() req:CompanyIdReq): Promise<CompanyBiMessageResponse> {
        try {
            return await this.biMsgService.getAllModulesandCompany(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CompanyBiMessageResponse, error);
        }
    }
    @Post('/getAllModuleForwhtsappLogs')
    async getAllModuleForwhtsappLogs(@Body() req:CompanyIdReq): Promise<CompanyBiMessageResponse> {
        try {
            return await this.biMsgService.getAllModuleForwhtsappLogs(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CompanyBiMessageResponse, error);
        }
    }

    @Post('/getTemplates')
    async getTemplates(): Promise<CommonResponse> {
        try {
            return await this.biMsgService.getTemplates();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/createWhatappLog')
    async createWhatappLog(@Body() dto:WhatsappLogsDto): Promise<any> {
        try {
            return await this.biMsgService.createWhatappLog(dto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

}
